import { createAsyncThunk } from "@reduxjs/toolkit";
import paymentsService from "../../../api/services/payments";

export const initiateRaiffeisenPayment = createAsyncThunk(
  "payments/initiateRaiffeisenPayment",
  async (orderData, { rejectWithValue }) => {
    try {
      return await paymentsService.initiateRaiffeisenPayment(orderData);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Bez rejectWithValue: unwrap() tako baca objekat sa .message iz handleError,
// pa toast može da prikaže poruku servera (npr. "već postoji rezervacija").
export const initiateWorkshopReservation = createAsyncThunk(
  "payments/initiateWorkshopReservation",
  async (reservationData) => {
    return await paymentsService.initiateWorkshopReservation(reservationData);
  },
);
